<script setup>
import { Modal, Icon,Input,Button,Select } from '@components';
import { ref,onMounted,computed } from 'vue';
import HoursEdit from '../settings/HoursEdit.vue';

import { sortedDays, toRGB } from '@utils'

import { useRouter } from 'vue-router';
const router = useRouter();

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useSetup } from '@store/setup'
const $setup = useSetup()

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()

import moment from 'moment';

const $options = prebook_admin.options

const useCalendar = () => {
   const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
   const activeCalender = ref({
      month: 1, // Specify the month (1 for January, 2 for February, etc.)
      year: 0, // Specify the year
      dates: [],
   });

   onMounted(() => {
      activeCalender.value.month = new Date().getMonth() + 1;
      activeCalender.value.year = new Date().getFullYear();
   });

   // generate dates
   const generateDates = () => {
      const selectedDate = moment();
      const startDayOfCalenderWeek = sortedDays()[0];

      activeCalender.value.dates = [];

      let dayToAddStart = (selectedDate.day() + 7 - days.indexOf(startDayOfCalenderWeek)) % 7;
      let dateStart = selectedDate.subtract(dayToAddStart, 'days');

      for (let i = 0; i < 7; i++) {
         activeCalender.value.dates.push({
            day: dateStart.format('dddd'),
            date: dateStart.date(),
            month: dateStart.format('MMMM'),
            year: dateStart.format('YYYY'),
            fullDate: dateStart.format('YYYY-MM-DD'),
         });

         dateStart.add(1, 'days');
      }

   };

   // get dates for calender
   const getDates = computed(() => {
      generateDates();
      return activeCalender.value.dates;
   });

   // check if today
   const isToday = (fullDate) => {
      return moment().format('YYYY-MM-DD') === fullDate;
   };

   // check if current month
   const isCurrentMonth = (fullDate) => {
      return moment(`${activeCalender.value.year}-${activeCalender.value.month}`, 'YYYY-M').format('YYYY-MM') === moment(fullDate, 'YYYY-MM-DD').format('YYYY-MM');
   };


   return { getDates, isToday, isCurrentMonth, activeCalender };
};
const { getDates, isToday, isCurrentMonth, activeCalender } = useCalendar()

const backButton = () => {
	router.push({name:'setup.info'})
}

const nextButton = async() => {
   // prebook_admin.setup.hours_updated = false
   await $settings.saveSettings('business_hours', $settings.businessHours);
   await $settings.saveSettings('payment', $settings.payment);
   await $settings.saveSettings('service', $settings.getSettings.service);
	await $setup.saveSetupStep('brand')
	router.push({name:'setup.brand'})
}

const progressHeight = () => {
   return  Math.round(Math.random() * 60)
}

// const formData = ref({})
const defaultServiceDuration = ref('');

onMounted(() => {
   defaultServiceDuration.value = `${$settings.getSettings.service?.default_duration} ${$settings.getSettings.service?.default_duration_unit == 'minute' ? 'min' : 'h'}`;
})

const serviceDurationOptions = ref([
   { label: '5 min', value: '5 min' },
   { label: '10 min', value: '10 min' },
   { label: '15 min', value: '15 min' },
   { label: '20 min', value: '20 min' },
   { label: '30 min', value: '30 min' },
   { label: '45 min', value: '45 min' },
   { label: '1 h', value: '1 h' },
   // { label: '1 h 30 min', value: '1 h 30 min' },
   { label: '2 h', value: '2 h' }
])

const durationMap = ref({
   '5 min': { duration: 5, duration_unit: 'minute' },
   '10 min': { duration: 10, duration_unit: 'minute' },
   '15 min': { duration: 15, duration_unit: 'minute' },
   '20 min': { duration: 20, duration_unit: 'minute' },
   '30 min': { duration: 30, duration_unit: 'minute' },
   '45 min': { duration: 45, duration_unit: 'minute' },
   '1 h': { duration: 1, duration_unit: 'hour' },
   '1 h 30 min': { duration: 1.5, duration_unit: 'hour' },
   '2 h': { duration: 2, duration_unit: 'hour' },
})

const setDefaultServiceDuration = () => {
   let option = durationMap.value[defaultServiceDuration.value];

   $settings.getSettings.service.default_duration = option.duration;
   $settings.getSettings.service.default_duration_unit = option.duration_unit;
}

const currencies = computed(() => {
   let uniqueCurrencies = new Set();
   let options = [];

   $options.countries?.forEach((country) => {
      if (!uniqueCurrencies.has(country.currency)) {
         options.push({
            label: country.currency + ' - ' + country.symbol,
            value: country.currency,
            tags: [country.name, country.code],
         });
         uniqueCurrencies.add(country.currency);
      }
   });

   return options;
});

const changedCurrency = (value) => {
   $settings.payment.currency = value;
   $settings.payment.currency_symbol = $options.countries.find((country) => country.currency === value).symbol;
};

const getTimeSlots = computed(() => {
   let currentDayName = moment().format('dddd')
   console.log(defaultServiceDuration.value); // output: 30 min
   let start = $settings.businessHours[currentDayName]?.enabled? $settings.businessHours[currentDayName]?.hours[0].start :'9:00 AM'
   let end = $settings.businessHours[currentDayName]?.enabled? $settings.businessHours[currentDayName]?.hours[0].end :'5:00 PM'
   // data
   let timeSlots = [];
   if (start) {
      let currentTime = moment(start, 'HH:mm');
      // Parse duration value (e.g., "30 min" or "1 h")
      let durationMatch = defaultServiceDuration.value.match(/(\d+)\s*(min|h)/);
      if (durationMatch) {
         let [_, value, unit] = durationMatch;
         let minutes = unit === 'h' ? parseInt(value) * 60 : parseInt(value);
         
         for (let i = 0; i < 6; i++) {
            timeSlots.push(currentTime.format('HH:mm'));
            currentTime.add(minutes, 'minutes');
         }
      }
   }

   return timeSlots;
});

const timePeriod = (slot_start) => {
    const hour = moment(slot_start, 'HH:mm').hour()

    if (hour >= 6 && hour < 12) {
        return 'Morning'
    } else if (hour >= 12 && hour < 18) {
        return 'Afternoon'
    } else {
        return 'Evening'
    }
}

const timeIcon = ref({
    Morning: 'sunSetting02',
    Afternoon: 'sun',
    Evening: 'moonStar',
})


</script>


<template>
  	<Modal :progress="66" class="transition duration-100 bg-white" contentClass="!p-0">
      <template #header>
			<div class="px-8 py-5 border-b-[#EAECF0] border-b flex items-center justify-between shadow-[0px_3px_0px_0px_#eaecf0]">
            <Icon name="logoLight" size="56px"/>
            <Icon @click="$setup.crossButton" class="cursor-pointer" name="xClose" size="30px"></Icon>
			</div>
		</template>

      <template #default>
        <div class="flex">
         <div class="w-full md:w-[calc(100%-738px)] h-full mb-5">
            <div class="mt-[70px] max-w-[750px] m-auto px-8 lg:px-[48px]">
               <div class="text-base font-medium text-[#101828]">General / <span class="font-bold">{{ $setup.isBusiness ? 'Business' : 'Individual' }}</span></div>
               <div class="text-[30px] font-bold text-[#101828] mt-2">Availability</div>
               <div class="text-base text-[#475467] mt-2">
                  {{ $setup.isBusiness ? 'When are you open for bookings? Configure your general availability here. You can skip this step, and default availability will apply until you update it in settings.' : 'When are you open for bookings? Configure your general availability here. You can skip this step, and default availability will apply until you update it in settings.' }}
               </div>

               <div class="mt-10 relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="text-[#101828] text-[20px] font-medium">Set your working hours to let clients know when you're available.</div>
                   <!-- <div class="border border-[#D0D5DD] rounded-[10px] p-5 mt-5 h-[100px]"></div> -->
                    <HoursEdit class="mt-5" />
               </div>
               <div class="mt-[30px] relative">
                  <Icon name="arrowRight" size="18px" class="absolute top-1 left-[-30px] text-[#101828]"></Icon>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
                     <!-- <div>
                        <div class="text-[#101828] text-[20px] font-medium">Time Zone</div>
                        <Select iconLeft="globe05" iconLeftClass="!text-[#000000] " v-model="formData.time_zone" placeholder="Select time zone" :options="[{label:'Eastern Time - US & Canada (15:52)',value:'Eastern Time - US & Canada (15:52)'}]" class="mt-5"></Select>
                     </div> -->
                     <div>
                        <div class="text-[#101828] text-[20px] font-medium">Default service duration</div>
                        <Select v-model="defaultServiceDuration" :options="serviceDurationOptions" class="mt-5" @change="setDefaultServiceDuration"></Select>
                     </div>
                     <!-- <div>
                        <div class="text-[#101828] text-[20px] font-medium">Appointment Type</div>
                        <Select v-model="formData.appointment_type" placeholder="Select appointment type" :options="[{label:'In-person',value:'In-person'},{label:'Online',value:'Online'}]" class="mt-5"></Select>
                     </div> -->
                     <div>
                        <div class="text-[#101828] text-[20px] font-medium">Choose your currency</div>
                        <Select search @change="changedCurrency" :options="currencies" v-model="$settings.payment.currency" class="mt-5"></Select>
                     </div>
                  </div>
               </div>

               <div class="flex items-center gap-10 mt-10">
                  <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between" @click="backButton">
                     <div class="w-[70%]">Back</div>
                     <template #before>
                        <Icon name="arrowNarrowLeft" size="20px"></Icon>
                     </template>
                  </Button>
                  <Button size="xl" type="primary" radius="square" classButton="w-full justify-between" @click="nextButton">
                     <div class="w-[95%]">Continue</div>
                     <template #after>
                        <Icon name="arrowNarrowRight" size="20px"></Icon>
                     </template>
                  </Button>
               </div>
            </div>
         </div>
         <div class="hidden md:block relative w-[738px] min-h-full overflow-hidden">
            <div class="circle-1"></div>
            <div class="circle-2"></div>
            <div class="circle-3"></div>
            <div class="text-lg font-medium text-[#344054] mt-[26px] ml-[36px] relative">Preview</div>
            <div class="w-[563px] m-auto mt-[67px] rounded-[20px] overflow-hidden relative">
               <img :src="Image('setup-availability.png')" />
               <div class="py-[22px] px-[30px] bg-white">
                  <div class="text-[#344054] text-base font-semibold px-[10px] py-[17px]">January 2023</div>
                  <div class="bg-[#EAECF0] w-full h-[1px]"></div>

                  <div class="flex items-end gap-2">
                     <div class="w-full">
                  
                        <!-- calendar days  -->
                        <div class="grid grid-cols-7 gap-7 justify-items-center items-center mb-2">
                           <div v-for="day in sortedDays()" :key="day" class="flex justify-center items-center w-10 h-10 text-sm leading-5 font-medium text-[#667085]">{{day.slice(0, 3) }}</div>
                        </div>
                  
                        <!-- calendar dates  -->
                        <div class="grid grid-cols-7 gap-7 justify-items-center items-center">
                           <div v-for="item in getDates" :key="item"
                              class="relative overflow-hidden flex justify-center items-center w-14 h-10 text-base leading-6 font-semibold"
                              :class="{ 'text-white border-2 border-solid': isToday(item.fullDate), 'border cursor-pointer text-[#344054] border-[#e9d7fe]': isCurrentMonth(item.fullDate) && !isToday(item.fullDate) }, { 'rounded': $customizer.isRounded }"
                              :style="`background-color: ${isToday(item.fullDate) ? `${$settings.customizer.design.brand_color} !important` : 'transparent'}; border-color: ${isToday(item.fullDate) ? `${$settings.customizer.design.brand_color} !important` : ''}`">
                              <div class="z-10">{{ item.date }}</div>
                              <div class="absolute bottom-0 left-0 w-full transition-all" :style="`height:${progressHeight()}%; background-color: ${toRGB($settings.customizer.design.brand_color, 0.3)} !important;`"></div>
                           </div>
                        </div>
                  
                     </div>
                  </div>

                  <div class="bg-[#EAECF0] w-full h-[1px] my-[26px]"></div>
                  <div class="text-[#475467] text-sm mb-4">Pick a time slot for January 9</div>
                  <div class="grid grid-cols-3 gap-4">
                     <div v-for="slot in getTimeSlots" :key="slot" class="flex items-center justify-center gap-2 text-black bg-[#F2F4F7] py-3 rounded-md cursor-pointer">
                        <Icon :name="timeIcon[timePeriod(slot)]" size="20px"/>
                        {{ moment(slot, 'HH:mm').format('hh:mm A') }}
                     </div>
                  </div>
               </div>
            </div>
         </div>
        </div>
      </template>
  	</Modal>
</template>

<style>
</style>